import axiosInstance from "api/axiosInstance";
import { BannerImageUploadResponse } from "api/types/marketing.types";

import type { NoticeCreateRequest, NoticeDetail, NoticeListResponse } from "api/types/notice.types";

const BASE = "/server/buccl_main/api/v1/admin/notices/";

export interface NoticeListParams {
  page?: number;
  page_size?: number;
}

export const noticesService = {
  list: (params?: NoticeListParams) => axiosInstance.get<NoticeListResponse>(BASE, { params }),

  get: (id: number) => axiosInstance.get<NoticeDetail>(`${BASE}${id}/`),

  create: (payload: NoticeCreateRequest) => axiosInstance.post<NoticeDetail>(BASE, payload),

  update: (id: number, payload: Partial<NoticeCreateRequest>) =>
    axiosInstance.patch<NoticeDetail>(`${BASE}${id}/`, payload),

  remove: (id: number) => axiosInstance.delete(`${BASE}${id}/`),
  uploadBannerImage: (file: File) => {
    const fd = new FormData();
    fd.append("image", file);
    return axiosInstance.post<BannerImageUploadResponse>(
      "/server/buccl_main/api/v1/upload-image/notice/",
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },
};
